// extracted by mini-css-extract-plugin
export var addButton = "_jf-0";
export var border = "_jf-8";
export var check = "_jf-h";
export var danger = "_jf-6";
export var dropdownContainer = "_jf-1";
export var editModalBody = "_jf-j";
export var footerContainer = "_jf-i";
export var fullWidth = "_jf-a";
export var hide = "_jf-9";
export var icon = "_jf-3";
export var input = "_jf-7";
export var inputFlex = "_jf-b";
export var inputWrapper = "_jf-c";
export var manualFocus = "_jf-5";
export var optionButton = "_jf-4";
export var pillWrapper = "_jf-e";
export var pointer = "_jf-2";
export var showOverflow = "_jf-f";
export var tagsFlex = "_jf-d";
export var xButton = "_jf-g";